
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarFlag as ObiBuoyPilarFlagElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-flag.js';
 
 
 

 
 export const ObiBuoyPilarFlag = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-flag',
   elementClass: ObiBuoyPilarFlagElement,
   events: {
     
   }
  });
 
 